module.exports = __webpack_public_path__ + "static/blog-ebpf-2d9aa6b5dc200815abc5e8b1a6099979.jpeg";